module.exports = __webpack_public_path__ + "static/brochure-c98d4da0e4745c9440012f354aaa3850.png";